import WTooltip from './tooltip.vue';
import WPreview from './preview-value.vue';
import WInput from './input.vue';
import WTextarea from './textarea.vue';
import WCheckbox from './checkbox.vue';
import WRadio from './radio';
import WError from './error.vue';
import WButton from './button.vue';
import WPagination from './pagination.vue';
import WSelect from './select.vue';
import WDatepicker from './datepicker.vue';
import WModal from './modal.vue';
import WSection from './section.vue';
import WCrossedOut from './crossed-out.vue';
import WAutoText from './auto-text.vue';
import WAlert from './alert.vue';
import WAddRow from './add-row.vue';
import WRowButtons from './row-buttons.vue';
import WTableCell from './table-cell.vue';
import WLpCell from '../components/lp-cell.vue';
import WFormTable from '../components/form-table.vue';
import WSpoiler from '../components/spoiler.vue';
import WRadioList from './radio-list.vue';

//shared components
import WAddress from './shared/Address.vue';
import WLegalForm from './shared/LegalForm.vue';
import WSphere from './shared/Sphere.vue';
import WFormDevTools from './shared/FormDevTools.vue';


export const components = {
  WInput,
  WPreview,
  WTextarea,
  WPagination,
  WSelect,
  WDatepicker,
  WModal,
  WRadio,
  WTooltip,
  WError,
  WAddRow,
  WRowButtons,
  WButton,
  WCheckbox,
  WSection,
  WTableCell,
  WCrossedOut,
  WAutoText,
  WAlert,
  WLpCell,
  WFormTable,
  WSpoiler,
  WRadioList,

  WAddress,
  WLegalForm,
  WSphere,
  WFormDevTools
};

export function registerComponents(Vue) {
  for (var name in components) {
    // console.log('register:', name);
    Vue.component(name, components[name]);
  }
}


export default components;
